import { Pipe, PipeTransform } from '@angular/core';
 
@Pipe({ name: 'snake_case' })
export class SnakeCasePipe implements PipeTransform {
  transform(input: string): string {
    return this.toSnakeCase(input);
  }

  toSnakeCase(s): string {
    // remove all characters that should not be in a variable name
    // as well underscores an numbers from the beginning of the string
    s = s.replace(/([^a-zA-Z0-9_\- ])|^[_0-9]+/g, "").trim().toLowerCase();

    // uppercase letters preceeded by a hyphen or a space
    s = s.replace(/\.?([A-Z])/g, function (x,y){return "_" + y.toLowerCase()}).replace(/^_/, "");

    s = s.replace(" ", "_");

    return s;
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/pipes/snake-case.pipe.ts